/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsLanding_similarItems = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
            readonly categoryPath: string | null;
            readonly categoryCode: string | null;
            readonly browseUrl: string | null;
            readonly title: string | null;
            readonly ecommerceTrackingParams: unknown | null;
            readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemCarousel_item">;
        } | null;
    } | null> | null;
    readonly " $refType": "PdpRespSimilarItemsLanding_similarItems";
};
export type PdpRespSimilarItemsLanding_similarItems$data = PdpRespSimilarItemsLanding_similarItems;
export type PdpRespSimilarItemsLanding_similarItems$key = {
    readonly " $data"?: PdpRespSimilarItemsLanding_similarItems$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsLanding_similarItems">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsLanding_similarItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "moreLikeThisEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "Item",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "serviceId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryPath",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryCode",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "browseUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "ecommerceTrackingParams",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemCarousel_item",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'bbd0a7e2599412079a10686adbdb5a8b';
export default node;
